import(/* webpackMode: "eager" */ "/netflix-clone/app/global-error.tsx");
